<!-- MFITTのシートマップ画面で、選択中の座席をリセットする確認ダイアログ -->
<template>
  <ItemDialog ref="confirmResetSelectedSeat" imageType="alert">
    <template v-slot:content-area>
      <h2>選択中の座席が解除されます</h2>
      <p class="text-center">
        号車を変更すると選択中の座席が解除されます。<br />
        号車を変更してよろしいですか？
      </p>
    </template>
    <template v-slot:button-area>
      <ItemButton label="OK" actionType="btn-primary" @clicked="ok()" />
      <ItemButton
        label="キャンセル"
        actionType="btn-cancel"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogConfirmResetSelectedSeat",
  props: {
    clickOk: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const selectedCar = ref(null);
    const confirmResetSelectedSeat = ref(null);

    const ok = () => {
      props.clickOk(selectedCar.value);
      confirmResetSelectedSeat.value.close();
    };

    const openDialog = (selectCar) => {
      selectedCar.value = selectCar;
      confirmResetSelectedSeat.value.open();
    };

    const closeDialog = () => {
      confirmResetSelectedSeat.value.close();
    };

    return {
      confirmResetSelectedSeat,
      ok,
      openDialog,
      closeDialog,
    };
  },
};
</script>
